module.exports = __webpack_public_path__ + "/login_ui/img/mr-59b9f4df71098ecf6392b66d7b1c1966.svg";